/**
 * 통합 리버스 지오코딩 API
 * 한국: 기존 백엔드 API
 * 해외: Nominatim (OSM)
 */

import { isKoreaRegion } from "../utils/mapUtils";
import { getRoadAddress } from "./detect";
import { getNominatimAddress } from "./nominatim";

/**
 * 좌표를 주소로 변환 (통합 함수)
 * @param lat 위도
 * @param lng 경도
 * @returns 주소 문자열
 */
export const getAddressFromCoords = async (
  lat: number,
  lng: number
): Promise<string> => {
  try {
    // 한국 영역 체크
    if (isKoreaRegion(lat, lng)) {
      // 한국: 기존 백엔드 API (정확함)
      const response = await getRoadAddress({ lat, lng });
      // getRoadAddress는 response.data를 리턴하므로 response.result.result로 접근
      return response?.result?.result || "주소 조회 실패";
    } else {
      // 해외: Nominatim (OSM)
      return await getNominatimAddress(lat, lng);
    }
  } catch (error) {
    console.error("Reverse geocoding error:", error);
    return "주소 조회 실패";
  }
};

